<!-- Actions for View Partners/View Partner Requests page -->
<template>
	<div>
		<div class="text-center" v-if="user_role !== 'guest'">
			<div class="inline-flex">
				<vx-tooltip :text="'View'" position="bottom" class="inline-flex mr-2 cursor-pointer">
					<feather-icon icon="EyeIcon" :svgClasses="`action-icons cursor-pointer`" @click="viewPartner()"/>
				</vx-tooltip>

				<span class="br-line mr-2 ml-2" v-if="params.reqType !== 'new-req' && params.reqType !=='edit-req' && (isEditDisabledVisible || isEditEnabledVisible)"></span>
			</div>

			<div v-if="isEditDisabledVisible" class="inline-flex cursor-not-allowed">
				<vx-tooltip :text="'Edit'" position="bottom" class="inline-flex ml-2 cursor-pointer">
			  	<feather-icon icon="EditIcon" :svgClasses="`action-icons disabled`"/>
				</vx-tooltip>
			</div>
			<div v-else-if="isEditEnabledVisible" class="inline-flex" :class="user_role =='demo' ? 'disabled' : ''" >
			  <vx-tooltip :text="'Edit'" position="bottom" class="inline-flex ml-2 cursor-pointer">
				  <feather-icon icon="EditIcon" :svgClasses="`action-icons cursor-pointer`" @click="editPartner()"/>
			  </vx-tooltip>
			</div>
		</div>	
	</div>	
</template>

<script>
	export default {
		name: 'CellRendererViewAndEditPartnerActions',
		data() {
			return {  		
        source: '',
				registry: ''
			}
		},
		mounted() {
			this.source = this.params.source;
		},
		computed: {   
			user_role(){
			  return JSON.parse(localStorage.getItem("userDetails")).role;
			},
			isEditDisabledVisible() {
				if(this.source == 'registrar') {
					return false;
				} else {
					return (this.user_role == 'channel_admin' || this.user_role == 'superadmin' || this.user_role == 'channel_user')  && this.params.status == 'edit-pending' && this.params.reqType !== 'new-req' && this.params.reqType !=='edit-req';
				}
			},
			isEditEnabledVisible() {
				if(this.source == 'registrar') {
					return this.user_role == 'bi_admin' || this.user_role == 'channel_admin' || this.user_role == 'superadmin';
				} else {
					return (this.user_role == 'bi_admin' || this.user_role == 'superadmin' || this.user_role == 'channel_admin' || this.user_role == 'channel_user')  && this.params.status !== 'edit-pending' && this.params.reqType !== 'new-req' && this.params.reqType !=='edit-req';
				}
			},
			disableCNICFlag() {
				return this.$store.getters.getDisableCNICFlag;
			}
		},
		methods: {
			viewPartner() {
				var rowData = this.params;
        this.source = rowData.source;
				this.registry = rowData.registry ? rowData.registry : null;
				this.reqType = rowData.reqType ? rowData.reqType : null;

        if(this.source == 'registrar') {
					if(this.registry == 'cnic') {
						this.$root.$emit('openCNICRegistrarPopup', 'view', rowData.data.id, rowData.data);
					} else {
						this.$root.$emit('openTucowsRegistrarPopup', 'view', rowData.data.id, rowData.data);
					}
        } else {
          this.$root.$emit('openResellerPopup', 'view', this.reqType, rowData.data.id, rowData.data);
        }
			},
			editPartner() {
				var rowData = this.params;
        this.source = rowData.source;
				this.registry = rowData.registry ? rowData.registry : null;
				this.reqType = rowData.reqType ? rowData.reqType : null;

        if(this.source == 'registrar') {
          if(this.registry == 'cnic') {
            this.$root.$emit('openCNICRegistrarPopup', 'edit', rowData.data.id, rowData.data);
          } else {
            this.$root.$emit('openTucowsRegistrarPopup', 'edit', rowData.data.id, rowData.data);
          }
        } else {
          this.$root.$emit('openResellerPopup', 'edit', this.reqType, rowData.data.id, rowData.data);
        }
			},
		},
	}
</script>
<style lang="scss">
  .disabled{
		pointer-events: none;
        opacity: 0.4;
	}

	.action-icons {
		height: 16px;
		width: 16px;
	}
</style>